import { saveAllContestList, saveAllMatchesList, saveCompliteMatchList, saveLiveMatchBook, saveLiveMatchList, saveMatchPlayersList, saveScheduleList, saveUpcomingList } from "../slices/fantacyMatchSlice";
import store from "../store";
import FantacyMatchService from "../../services/fantacyMatchService";

export function getScheduleList() {
  return new Promise((resolve, rejact) => {
    FantacyMatchService.getScheduleService()
      .then((res) => {
        store.dispatch(saveScheduleList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form market", error)
        rejact(error);
      });
  });
}

export function postSaveSchedule(data) {
  return new Promise((resolve, rejact) => {
    FantacyMatchService.postSaveScheduleService(data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form postMarketModel", error)
        rejact(error);
      });
  });
}
export function postSavePlayersCredit(data) {
  return new Promise((resolve, rejact) => {
    FantacyMatchService.postSavePlayersCreditService(data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form postMarketModel", error)
        rejact(error);
      });
  });
}

export function getUpcomingList() {
  return new Promise((resolve, rejact) => {
    FantacyMatchService.getUpcomingListService()
      .then((res) => {
        store.dispatch(saveUpcomingList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form market", error)
        rejact(error);
      });
  });
}

export function getMatchPlayers(matchId) {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getMatchPlayers(matchId)
      .then((res) => {
        store.dispatch(saveMatchPlayersList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form market", error)
        reject(error);
      });
  });
}

export function getAllMatches() {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getAllMatchesService()
      .then((res) => {
        store.dispatch(saveAllMatchesList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form market", error)
        reject(error);
      });
  });
}

export function getAllContestList() {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getContestListService()
      .then((res) => {
        store.dispatch(saveAllContestList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form market", error)
        reject(error);
      });
  });
}

export function postCreateContest(data) {
  return new Promise((resolve, rejact) => {
    FantacyMatchService.postCreateContestService(data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        //console.log("Error getting form postMarketModel", error)
        rejact(error);
      });
  });
}

export function getLiveMatchList() {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getLiveMatchListService()
      .then((res) => {
        store.dispatch(saveLiveMatchList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        reject(error);
      });
  });
}

export function getLiveMatchBook(matchId) {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getLiveMatchBookService(matchId)
      .then((res) => {
        store.dispatch(saveLiveMatchBook(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        reject(error);
      });
  });
}

export function getCompliteMatchList() {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getCompliteMatchListService()
      .then((res) => {
        store.dispatch(saveCompliteMatchList(res.data));
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        reject(error);
      });
  });
}

export function setFnResult(matchId) {
  return new Promise((resolve, reject) => {
    FantacyMatchService.setFnResultService(matchId)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        reject(error);
      });
  });
}

export function setFnResultRollback(matchId) {
  return new Promise((resolve, reject) => {
    FantacyMatchService.setFnResultRollbackService(matchId)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        reject(error);
      });
  });
}

export function getUserTeamDetails(teamId, matchId) {
  return new Promise((resolve, reject) => {
    FantacyMatchService.getUserTeamDetailsService(teamId, matchId)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("loginUserDetails");
          window.location = "/login";
        }
        reject(error);
      });
  });
}